import React from "react";
import { ToggleSwitchProps } from "./ToggleSwitch.types";
import "./ToggleSwitch.scss";

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  onChange,
  showText,
}) => {
  return (
    <label className="toggleSwitch-container" htmlFor={id}>
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <span
        className={`toggleSwitch-background ${
          checked ? "toggleSwitch-background--checked" : ""
        }`}
      >
        {checked && showText && (
          <span className="toggleSwitch-label toggleSwitch-label--on">ON</span>
        )}
        <span
          className={`toggleSwitch-thumb ${
            checked ? "toggleSwitch-thumb--checked" : ""
          }`}
        />
        {!checked && showText && (
          <span className="toggleSwitch-label toggleSwitch-label--off">
            OFF
          </span>
        )}
      </span>
    </label>
  );
};

export default ToggleSwitch;
